import { clearExtensionErrors } from "@app/helpers/clear-extension-errors";
import { initializeApp } from "@app/helpers/initialize-app";

// eslint-disable-next-line no-console
console.info(`${APP_NAME}@${APP_VERSION}+${BUILD_ID}`);

clearExtensionErrors();
initializeApp();
